import React, { useMemo, useState, useEffect } from "react";
import {
  MenuItem,
  Divider,
  TextField,
  Button,
  Select,
  FormControl,
  InputLabel,
} from "@mui/material";

const OPS_TEXT = [
  { value: "contiene", label: "Contiene" },
  { value: "empieza con", label: "Empieza con" },
  { value: "termina con", label: "Termina con" },
];

const OPS_NUM = [
  { value: "contiene", label: "Contiene" },
  { value: "igual", label: "Igual" },
  { value: "mayor que", label: "Mayor que" },
  { value: "menor que", label: "Menor que" },
  { value: "entre", label: "Entre" },
  { value: "entre (inclusivo)", label: "Entre (inclusivo)" },
];

const VALIDITY = [
  { value: "VIGENTE", label: "Vigente" },
  { value: "EXPIRADO", label: "Vencido" },
  { value: "PROXIMO_A_EXPIRAR", label: "Próximo a vencer" },
  { value: "NO_EXISTENTE", label: "No existente" },
];

const STATUS = [
  { value: "Activo", label: "Activo" },
  { value: "Inactivo", label: "Inactivo" },
  { value: "proceso de integración", label: "En proceso" },
];

const PROYECTS = [
  { value: "Concluido", label: "Proyectos concluidos" },
  { value: "En proceso", label: "Proyectos en ejecución" },
  { value: "Inactivo", label: "Proyectos inactivos" },
];

const SPECIALTY = [
  { value: "Obra Civil", label: "Obra civil" },
  { value: "Energia Fotovoltaica", label: "Energía Fotovoltaica" },
  { value: "Enlaces", label: "Enlaces" },
  { value: "Comunicación Celular", label: "Comunicación Celular" },
  { value: "Eléctricas Menores", label: "Eléctricas Menores" },
  { value: "Eléctricas Mayores", label: "Eléctricas Mayores" },
  { value: "Trabajos en alta tensión", label: "Trabajos en alta tensión" },
  { value: "Cableado Estructurado", label: "Cableado Estructurado" },
  { value: "Sin especialidades", label: "Sin especialidades" },
];

const STRAIN = [
  { value: "BT", label: "Baja tensión" },
  { value: "MT", label: "Media tensión" },
  { value: "AT", label: "Alta tensión" },
];

// 1) Crea un handler reutilizable
const stopKeyDown = (e) => e.stopPropagation();

const FilterAndSortMenu = ({ column, closeMenu }) => {
  const variant = column.columnDef?.meta?.filterVariant || "texto";
  const initial = column.getFilterValue?.() || {};

  const [operator, setOperator] = useState(
    initial.operator ||
      (variant === "texto"
        ? "contiene"
        : variant === "numerico"
        ? "igual"
        : variant === "estado"
        ? "estado"
        : variant === "estatus"
        ? "estatus"
        : variant === "proyectos"
        ? "proyectos"
        : variant === "specialty"
        ? "specialty"
        : "strain")
  );

  const [value, setValue] = useState(() => {
    const v = initial.value;
    if (typeof v === "object") return v;
    return v ?? "";
  });

  const options = useMemo(() => {
    if (variant === "texto") return OPS_TEXT;
    if (variant === "numerico") return OPS_NUM;
    return [];
  }, [variant]);

  const isBetween = operator === "entre" || operator === "entre (inclusivo)";
  const isEstado = variant === "estado";
  const isEstatus = variant === "estatus";
  const isProyectos = variant === "proyectos";
  const isSpecialty = variant === "specialty";
  const isStrain = variant === "strain";

  useEffect(() => {
    if (isEstado || isEstatus || isProyectos || isSpecialty || isStrain) return;
    if (!options.find((o) => o.value === operator)) {
      setOperator(options[0]?.value || "igual");
      setValue("");
    }
  }, [
    options,
    operator,
    isEstado,
    isEstatus,
    isProyectos,
    isSpecialty,
    isStrain,
  ]);

  const applyFilter = () => {
    if (isEstado) {
      column.setFilterValue({ operator: "estado", value });
    } else if (isEstatus) {
      column.setFilterValue({ operator: "estatus", value });
    } else if (isProyectos) {
      column.setFilterValue({ operator: "proyectos", value });
    } else if (isSpecialty) {
      column.setFilterValue({ operator: "specialty", value });
    } else if (isStrain) {
      column.setFilterValue({ operator: "strain", value });
    } else {
      column.setFilterValue({ operator, value });
    }
    closeMenu();
  };

  const clearFilter = () => {
    column.setFilterValue(undefined);
    setValue("");
    setOperator(
      variant === "texto"
        ? "contiene"
        : variant === "numerico"
        ? "igual"
        : variant === "estado"
        ? "estado"
        : variant === "estatus"
        ? "estatus"
        : variant === "proyectos"
        ? "proyectos"
        : variant === "specialty"
        ? "specialty"
        : "strain"
    );
    closeMenu();
  };

  return (
    <>
      <MenuItem
        sx={{ fontFamily: "Nunito" }}
        onClick={() => {
          column.toggleSorting(false);
          closeMenu();
        }}
      >
        Orden ascendente
      </MenuItem>
      <MenuItem
        sx={{ fontFamily: "Nunito" }}
        onClick={() => {
          column.toggleSorting(true);
          closeMenu();
        }}
      >
        Orden descendente
      </MenuItem>

      <Divider />

      <div
        style={{
          padding: "1rem",
          width: "260px",
          fontFamily: "Nunito",
        }}
      >
        {!isEstado &&
          !isEstatus &&
          !isProyectos &&
          !isSpecialty &&
          !isStrain && (
            <FormControl fullWidth size="small" sx={inputSx}>
              <div style={{ marginBottom: "8px" }}>
                <InputLabel sx={{ fontFamily: "Nunito" }}>Operador</InputLabel>
              </div>
              <Select
                label="Operador"
                value={operator}
                onChange={(e) => {
                  setOperator(e.target.value);
                  setValue("");
                }}
                sx={selectSx}
              >
                {options.map((op) => (
                  <MenuItem
                    key={op.value}
                    value={op.value}
                    sx={{ fontFamily: "Nunito" }}
                  >
                    {op.label}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          )}

        {isEstado && (
          <FormControl fullWidth size="small" sx={inputSx}>
            <InputLabel sx={{ fontFamily: "Nunito" }}>Estado</InputLabel>
            <Select
              label="Estado"
              value={value || ""}
              onChange={(e) => setValue(e.target.value)}
              sx={selectSx}
            >
              {VALIDITY.map((eo) => (
                <MenuItem
                  key={eo.value}
                  value={eo.value}
                  sx={{ fontFamily: "Nunito" }}
                >
                  {eo.label}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        )}

        {isEstatus && (
          <FormControl fullWidth size="small" sx={inputSx}>
            <InputLabel sx={{ fontFamily: "Nunito" }}>Estatus</InputLabel>
            <Select
              label="Estatus"
              value={value || ""}
              onChange={(e) => setValue(e.target.value)}
              sx={selectSx}
            >
              {STATUS.map((es) => (
                <MenuItem
                  key={es.value}
                  value={es.value}
                  sx={{ fontFamily: "Nunito" }}
                >
                  {es.label}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        )}

        {isProyectos && (
          <FormControl fullWidth size="small" sx={inputSx}>
            <InputLabel sx={{ fontFamily: "Nunito" }}>Proyectos</InputLabel>
            <Select
              label="Proyectos"
              value={value || ""}
              onChange={(e) => setValue(e.target.value)}
              sx={selectSx}
            >
              {PROYECTS.map((pr) => (
                <MenuItem
                  key={pr.value}
                  value={pr.value}
                  sx={{ fontFamily: "Nunito" }}
                >
                  {pr.label}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        )}

        {isSpecialty && (
          <FormControl fullWidth size="small" sx={inputSx}>
            <InputLabel sx={{ fontFamily: "Nunito" }}>Especialidad</InputLabel>
            <Select
              label="Especialidad"
              value={value || ""}
              onChange={(e) => setValue(e.target.value)}
              sx={selectSx}
            >
              {SPECIALTY.map((sp) => (
                <MenuItem
                  key={sp.value}
                  value={sp.value}
                  sx={{ fontFamily: "Nunito, sans-serif" }}
                >
                  {sp.label}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        )}

        {isStrain && (
          <FormControl fullWidth size="small" sx={inputSx}>
            <InputLabel sx={{ fontFamily: "Nunito" }}>Strain</InputLabel>
            <Select
              label="Strain"
              value={value || ""}
              onChange={(e) => setValue(e.target.value)}
              sx={selectSx}
            >
              {STRAIN.map((st) => (
                <MenuItem
                  key={st.value}
                  value={st.value}
                  sx={{ fontFamily: "Nunito" }}
                >
                  {st.label}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        )}

        {!isEstado &&
          !isEstatus &&
          !isProyectos &&
          !isSpecialty &&
          !isStrain &&
          !isBetween && (
            <TextField
              fullWidth
              size="small"
              placeholder="Valor"
              value={value}
              onChange={(e) => setValue(e.target.value)}
              style={{ marginTop: "8px" }}
              sx={textFieldSx}
              onKeyDown={stopKeyDown}
            />
          )}

        {!isEstado &&
          !isEstatus &&
          !isProyectos &&
          !isSpecialty &&
          isBetween && (
            <div style={{ display: "flex", gap: "4px", marginTop: "8px" }}>
              <TextField
                size="small"
                placeholder="Mínimo"
                fullWidth
                value={value.min || ""}
                onChange={(e) => setValue({ ...value, min: e.target.value })}
                sx={textFieldSx}
                onKeyDown={stopKeyDown}
              />
              <TextField
                size="small"
                placeholder="Máximo"
                fullWidth
                value={value.max || ""}
                onChange={(e) => setValue({ ...value, max: e.target.value })}
                sx={textFieldSx}
                onKeyDown={stopKeyDown}
              />
            </div>
          )}

        <Button
          variant="contained"
          size="small"
          onClick={applyFilter}
          sx={{
            marginTop: "8px",
            backgroundColor: "#62C776",
            width: "126px",
            height: "31px",
            fontSize: "14px",
            color: "#FFFFFF",
            fontWeight: 700,
            textTransform: "none",
            fontFamily: "Nunito",
            "&:hover": { backgroundColor: "#55B86A" },
          }}
        >
          Aplicar filtro
        </Button>
        <Button
          variant="outlined"
          size="small"
          onClick={clearFilter}
          sx={{
            marginTop: "8px",
            width: "126px",
            height: "31px",
            fontSize: "14px",
            fontWeight: 700,
            color: "#62C776",
            borderColor: "#62C776",
            textTransform: "none",
            fontFamily: "Nunito",
            "&:hover": { backgroundColor: "#F5FFF8", borderColor: "#55B86A" },
          }}
        >
          Limpiar filtro
        </Button>

        <Divider style={{ margin: "8px 0" }} />

        <Button
          size="small"
          sx={actionSx}
          onClick={() => {
            column.pin("left");
            closeMenu();
          }}
        >
          Anclar a la izquierda
        </Button>
        <Button
          size="small"
          sx={actionSx}
          onClick={() => {
            column.pin("right");
            closeMenu();
          }}
        >
          Anclar a la derecha
        </Button>
        <br />
        <Button
          size="small"
          sx={actionSx}
          onClick={() => {
            column.pin(false);
            closeMenu();
          }}
        >
          Desanclar
        </Button>

        {column.getCanHide?.() && (
          <Button
            size="small"
            sx={{ fontFamily: "Nunito, sans-serif" }}
            onClick={() => {
              column.toggleVisibility(false);
              closeMenu();
            }}
          >
            Ocultar columna
          </Button>
        )}
      </div>
    </>
  );
};

const inputSx = {
  "& .MuiOutlinedInput-root": {
    "& fieldset": { borderColor: "#62C776" },
    "&:hover fieldset": { borderColor: "#55B86A" },
    "&.Mui-focused fieldset": { borderColor: "#62C776" },
  },
  fontFamily: "Nunito",
};

const selectSx = {
  "& .MuiSelect-select": { color: "#223d51", fontFamily: "Nunito" },
  fontFamily: "Nunito",
};

const textFieldSx = {
  "& .MuiOutlinedInput-root": {
    "& fieldset": { borderColor: "#62C776" },
    "&:hover fieldset": { borderColor: "#55B86A" },
    "&.Mui-focused fieldset": { borderColor: "#62C776" },
    fontFamily: "Nunito",
  },
  "& input": { color: "#223d51", fontFamily: "Nunito" },
};

const actionSx = {
  color: "#223d51",
  fontSize: "13px",
  textTransform: "none",
  borderRadius: "6px",
  fontFamily: "Nunito",
};

export default FilterAndSortMenu;
